export class Rol {
    get id() {
        return this.rolState.id;
    }
    get name() {
        return this.rolState.name;
    }
    get level() {
        return this.rolState.level;
    }
    constructor(rolState) {
        this.rolState = rolState;
    }
    getState() {
        return this.rolState;
    }
}
